var _excluded = ["app", "excludeArr", "onChange", "valueKey"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../../reducers/ppc.reducer';
import Select from '../Select.react';
var SelectPpcServiceCategory = function SelectPpcServiceCategory(_ref) {
  var _ref$app = _ref.app,
    app = _ref$app === void 0 ? '' : _ref$app,
    _ref$excludeArr = _ref.excludeArr,
    excludeArr = _ref$excludeArr === void 0 ? null : _ref$excludeArr,
    _onChange = _ref.onChange,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? '_id' : _ref$valueKey,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dispatch = useDispatch();
  var serviceCategoryList = useSelector(function (s) {
    return s.ppc.service.category;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.serviceCategory,
      payload: {}
    });
  }, []);
  useEffect(function () {
    var tmp = Object.values(serviceCategoryList).filter(function (x) {
      return app === '' || x.clientApp === app;
    }).filter(function (x) {
      return !x.archived;
    });
    setState(tmp);
  }, [serviceCategoryList, excludeArr, app]);
  var preValue = '';
  var postValue = '';
  if (valueKey === 'internalUrl') preValue = '/services/';
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: state.sort(function (a, b) {
      return a.title.localeCompare(b.title);
    }).map(function (x) {
      return {
        sLabel: x.title,
        sValue: preValue + '' + x[valueKey] + '' + postValue
      };
    })
  }, rest, {
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      if (_onChange) _onChange(sValue);
    }
  }));
};
export default SelectPpcServiceCategory;